export interface ProviderReadinessInput {
  destinationVerified: boolean
  locationAvailable: boolean
  krideEnabled: boolean
  uberEnabled: boolean
}

export interface ProviderReadiness extends ProviderReadinessInput {
  comparisonEnabled: boolean
  buttonEnabled: {
    kride: boolean
    uber: boolean
  }
}

export function providerReadiness(input: ProviderReadinessInput): ProviderReadiness {
  const comparisonEnabled = input.destinationVerified
    && input.locationAvailable
    && input.krideEnabled
    && input.uberEnabled

  return {
    ...input,
    comparisonEnabled,
    // Both Provider buttons share one eligibility condition to prevent A/B bias.
    buttonEnabled: {
      kride: comparisonEnabled,
      uber: comparisonEnabled,
    },
  }
}
